import { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { triggerA2CRecos } from '@/productDiscovery/Recommendation/modules/ProductRecommendation/ProductRecommendation.actions';

import { CategoriesTopSalesContainerA2C } from './components/CategoriesTopSalesContainerA2C/CategoriesTopSalesContainerA2C';
import { FBTContainerA2C } from './components/FBTContainerA2C/FBTContainerA2C';

interface Props {
  categoryId: number;
}

const RecosContainerA2C: FunctionComponent<Props> = ({ categoryId }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(triggerA2CRecos(categoryId));
  }, [dispatch, categoryId]);

  return (
    <>
      <FBTContainerA2C />
      <CategoriesTopSalesContainerA2C />
    </>
  );
};

RecosContainerA2C.displayName = 'RecosContainerA2C';

export default RecosContainerA2C;
